;(function($, undefined){

    var rnn = window.rnn;

    function build($wall){
        var settings = $wall.data("wall") || {};
        $wall.masonry({
            itemSelector : '.brick',
            columnWidth : parseInt(settings.columnWidth || 332,10) //outer width of 'bricks'
        });
    }

    // Initialise masonry
    function initMasonry() {
        var $containers = $('.wall');
        $containers.each(function(){
            var $container = $(this);
            build($container); //console.warn('Building 1'); //immediate build for shit code and browsers

            //Set an event for any time we ajax load something into this masonry container.
            $container.on('DOMNodeInserted', function(event){
                $(event.target).imagesLoaded(function(){
                    $(this).closest('.wall').masonry('appended', $(this));
                    $(this).closest('.wall').masonry('reload');
                    //console.warn('Reloading 2');
                });
            });

            //This seems insane, and really is... but why not!
            //For occasions and browsers that ARE doing the imagesLoaded callback
            $container.imagesLoaded(function(){
                build($container); //console.warn('Building 2');
            });
        });
    }

    rnn.modules.register('masonry', {
        init: initMasonry,
        build: build
    });

})(jQuery);